/// <amd-module name="ExtensionManagement/ManagementHub/RejectRequestDialog" />
import * as React from "react";

import { ObservableValue } from "VSS/Core/Observable";

import { Dialog } from "VSSUI/Dialog";
import { Observer } from "VSSUI/Observer";
import { TextField } from "VSSUI/TextField";

import { PublisherNameComponent } from "./PublisherNameComponent";
import { IExtensionViewModel } from "./UIContracts";

import * as Resources from "ExtensionManagement/ManagementHub/Resources.ExtManagmentHub";

interface IRejectRequestDialogProps {
    /**
     * Extenion request to be rejected
     */
    extension: IExtensionViewModel;

    /**
     * Callback function if user rejects request from dialog
     */
    onContinueRejectRequest: (reason: string) => void;

    /**
     * Callback function on dialog dismiss
     */
    onDismiss: () => void;
}

/**
 * Dialog that lets user reject a request with a reason
 */
export class RejectRequestDialog extends React.Component<IRejectRequestDialogProps> {
    rejectReason = new ObservableValue<string>("");
    rejectButtonEnabled = new ObservableValue<boolean>(false);

    public render(): JSX.Element {
        return (
            <Observer rejectButtonEnabled={this.rejectButtonEnabled}>
                {(props: { rejectButtonEnabled: boolean }) => {
                    return (
                        <Dialog
                            titleProps={{ text: Resources.RejectRequestHeading }}
                            footerButtonProps={[
                                { text: Resources.Reject, primary: true, onClick: this.onReject, disabled: !props.rejectButtonEnabled },
                                {
                                    text: Resources.Cancel,
                                    onClick: this.props.onDismiss
                                }
                            ]}
                            onDismiss={this.props.onDismiss}
                        >
                            <div className="flex-grow reject-request-dialog-content">
                                <img alt="" className="extension-icon" src={this.props.extension.extensionIconUrl} />
                                <div className="flex-grow flex-column">
                                    <div className="extension-name">{this.props.extension.extensionName}</div>
                                    <PublisherNameComponent extension={this.props.extension} />
                                </div>
                                <p>{Resources.RequesterNotification}</p>
                                <TextField
                                    className="textfield-reject-reason"
                                    label={Resources.RejectReasonQuestion}
                                    value={this.rejectReason}
                                    onChange={this.onChangeRejectReason}
                                    multiline={true}
                                    rows={5}
                                    maxLength={300}
                                />
                            </div>
                        </Dialog>
                    );
                }}
            </Observer>
        );
    }

    private onChangeRejectReason = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>, newValue: string) => {
        this.rejectReason.value = newValue;
        this.rejectButtonEnabled.value = newValue !== "";
    };

    private onReject = (): void => {
        this.props.onContinueRejectRequest(this.rejectReason.value);
    };
}
